var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1473_37951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 0H10C4.47715 0 0 4.47715 0 10V38C0 43.5228 4.47715 48 10 48H38C43.5228 48 48 43.5228 48 38V10C48 4.47715 43.5228 0 38 0Z",
    fill: "#E7F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9.5C14.3807 9.5 15.5 10.6193 15.5 12C15.5 13.3807 14.3807 14.5 13 14.5C11.6193 14.5 10.5 13.3807 10.5 12C10.5 10.6193 11.6193 9.5 13 9.5Z",
    fill: "#3293F7",
    stroke: "#3293F7",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13 21.5C14.3807 21.5 15.5 22.6193 15.5 24C15.5 25.3807 14.3807 26.5 13 26.5C11.6193 26.5 10.5 25.3807 10.5 24C10.5 22.6193 11.6193 21.5 13 21.5Z",
    stroke: "#378ADD",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13 33.5C14.3807 33.5 15.5 34.6193 15.5 36C15.5 37.3807 14.3807 38.5 13 38.5C11.6193 38.5 10.5 37.3807 10.5 36C10.5 34.6193 11.6193 33.5 13 33.5Z",
    stroke: "#378ADD",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 8,
    width: 18,
    height: 8,
    rx: 4,
    fill: "#3293F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 20,
    width: 18,
    height: 8,
    rx: 4,
    fill: "#B1D2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 32,
    width: 18,
    height: 8,
    rx: 4,
    fill: "#B1D2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1473_37951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/QuestionIcon.134a4278af0eefb0224680ec79975516.svg";
export { ForwardRef as ReactComponent };